module.exports = __webpack_public_path__ + "static/media/homepage-section-6-phone-2.0488f5cd.png";